import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import * as Styled from './OpeningIndicator.styles'
import { ThemeContext } from 'styled-components'

const OpeningIndicator = ({ type, untilMsg, className = '' }) => {
  const theme = useContext(ThemeContext)

  /**
   * get state depending color for the indicator circle
   **/
  const getIndicatorColor = () => {
    let color
    switch (type) {
      case 'closedSoon':
        color = theme.colors.openTimeClosedSoon
        break

      case 'closed':
      case 'closed_until_other_day':
        color = theme.colors['fehler-rot']
        break

      case 'no_information':
        color = theme.colors['icon-grau2']
        break

      case 'open':
      default:
        color = theme.colors.hellgruen1
        break
    }

    return color
  }

  return (
    <Styled.Container
      className={ className }
      data-cy='opening-indicator'
      data-cy-opening-indicator-type={ type }>
      <Styled.Indicator color={ getIndicatorColor() } />
      {untilMsg}
    </Styled.Container>
  )
}

OpeningIndicator.propTypes = {
  type: PropTypes.oneOf([
    'open',
    'closedSoon',
    'closed',
    'closed_until_other_day',
    'no_information',
  ]).isRequired,
  untilMsg: PropTypes.string.isRequired,
}

export default OpeningIndicator
